import { FaUserTie, FaLaptopCode, FaUsers, FaRocket } from "react-icons/fa";

export const accordionData = [
  {
    id: 1,
    title: "Do you offer plans for both individuals and teams ?",
    content: (
      <>
        <p>Yes. Simplifyte has two flexible pricing tracks:</p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>
            <strong style={{ color: "#093a5b" }}>Per User Plans</strong>{" "}
            (monthly or yearly) — perfect for freelancers, consultants, and
            smaller teams.
          </li>
          <li>
            <strong style={{ color: "#093a5b" }}>Team Plans</strong> (yearly
            only) — ideal for growing companies or large organizations looking
            for volume-based control and value.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    title: "What’s the difference between Per User and Team Plans ?",
    content:
      "Per User Plans scale as you grow — you pay based on how many people use the platform. Team Plans give you a bundled user quota at a fixed rate, along with admin tools and advanced features built for team-wide efficiency.",
  },
  // {
  //   id: 3,
  //   title: "Is there a free version of Simplifyte ?",
  //   content:
  //     "Yes! Our Free plan is perfect for small-scale use — it includes tasks, limited storage, and client tracking to help you get started without commitment.",
  // },
  {
    id: 4,
    title: "Can I pay monthly ?",
    content: (
      <p>
        Yes — but only for{" "}
        <strong style={{ color: "#093a5b" }}>Per User Plans</strong>. Team Plans
        are billed annually to offer better value at scale.
      </p>
    ),
  },
  {
    id: 5,
    title: "Can I try a paid plan before committing ?",
    content:
      // "Absolutely. Every paid plan starts with a 30-day free trial — no credit card required.",
      "Yes. We offer a free trial of our Elite plan, so you can explore all premium features before committing. No credit card required.",
  },
  {
    id: 6,
    title: "Can I switch plans later ?",
    content:
      "Yes, you can upgrade, downgrade, or move between Per User and Team Plans at any time from your billing dashboard.",
  },
  {
    id: 7,
    title:
      "Do you offer special pricing for startups, NGOs, or educational institutions?",
    content: (
      <p>
        {/* We do. Email [
        <a
          href="mailto:sales@simplifyte.com"
          className="text-indigo-600 hover:underline"
        >
          sales@simplifyte.com
        </a>
        ] and we’ll work with you to find the best plan. */}
        Yes. We offer special pricing for eligible startups, NGOs, and
        educational institutions. Email{" "}
        <a
          href="mailto:sales@simplifyte.com"
          className="text-indigo-600 hover:underline"
        >
          sales@simplifyte.com
        </a>
        and our team will help you choose the right plan.
      </p>
    ),
  },
  {
    id: 8,
    title: "What happens if I hit my task or storage limits ?",
    content: (
      <>
        <p>
          No worries — you stay in control. When you approach your limits, we’ll
          give you a "heads up" (no surprises).
        </p>
        <p className="mt-2">You can either:</p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>Optimize your current workspace</li>
          <li>
            Or upgrade with one of our Storage Add-ons designed to scale as you
            do:
          </li>
        </ul>
        <ul className="list-disc list-inside mt-2 space-y-1 pl-4">
          <li>
            🪶 <strong style={{ color: "#093a5b" }}>Simplifyte Lite</strong> —
            <span className="">For light users and smaller firms</span>
          </li>
          <li>
            🚀 <strong style={{ color: "#093a5b" }}>Simplifyte Plus</strong> —
            Perfect for mid-sized teams with growing storage needs
          </li>
          <li>
            🛸 <strong style={{ color: "#093a5b" }}>Simplifyte Max</strong> —
            For high-volume teams that need space to fly
          </li>
        </ul>
        <p className="mt-2">
          These flexible data packs are available across most plans and can be
          added anytime — so you’re never grounded.
        </p>
      </>
    ),
  },
  {
    id: 9,
    title: "Can I import my data from other tools ?",
    content:
      "Yes. Simplifyte supports bulk import of tasks, clients, and files. We also provide onboarding support to make migration easy.",
  },
  {
    id: 11,
    title: "What payment methods do you accept ?",
    content: (
      <p>
        All major credit/debit cards are accepted. Invoice-based billing is
        available for <strong style={{ color: "#093a5b" }}>Elite Plan.</strong>
      </p>
    ),
  },
];

export const corporateServices2 = [
  {
    icon: FaUserTie,
    title: "Modern Consultants",
    desc: "Professionals who guide teams in tech, finance, law, or strategy — and want to offer smarter workflows.",
  },
  {
    icon: FaLaptopCode,
    title: "Tech-Driven Agencies",
    desc: "Teams with a passion for digital transformation, automation, and client-first SaaS solutions.",
  },
  {
    icon: FaUsers,
    title: "Community Builders",
    desc: "Creators, educators, and content pros who influence how teams work, learn, and grow.",
  },
  {
    icon: FaRocket,
    title: "Growth-Focused Entrepreneurs",
    desc: "Visionaries with networks, ideas, and the drive to bring meaningful tools to more people.",
  },
];
